import React, { useMemo } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { backYouTheme } from '../../../../theme';
import { useTranslation } from 'react-i18next';

export default function AutocompleteBaseInput(props) {
	const { t: gctrad } = useTranslation();
	const {
		getOptionLabel,
		filterOptions,
		options,
		variant = 'standard',
		autoComplete = false,
		autoHighlight = false,
		includeInputInList = false,
		filterSelectedOptions = false,
		multiple = false,
		value,
		onChange,
		onInputChange,
		renderInput,
		renderOption,
		noOptionsText = null
	} = props;

	const AutocompleteTheme = useMemo(() =>
		createTheme({
			palette: {
				primary: backYouTheme.palette.primary,
				secondary: backYouTheme.palette.secondary
			},
			typography: backYouTheme.typography
		}),
	[backYouTheme]);
	
	return (
		<ThemeProvider theme={AutocompleteTheme}>
			<Autocomplete
				{...props}
				multiple={multiple}
				getOptionLabel={getOptionLabel}
				filterOptions={filterOptions}
				options={options}
				variant={variant}
				autoComplete={autoComplete}
				autoHighlight={autoHighlight}
				includeInputInList={includeInputInList}
				filterSelectedOptions={filterSelectedOptions}
				value={value}
                noOptionsText={noOptionsText ?? gctrad('[:myspace] Aucun résultat')}
				onChange={(event, value) => onChange(event, value)}
				onInputChange={(event, value, reason) => onInputChange(event, value, reason)}
				loadingText={'recherche_en_cours'.trad()}
				renderInput={renderInput}
				renderOption={renderOption}
			/>
		</ThemeProvider>
	);
}